// Input value resolvers

/*
 * Function type definition for each resolver:
 * ({
 *  control: HTMLInputElement;
 *  // `disabled` attribute value
 *  disabled: boolean;
 *  // `name` attribute value
 *  name: string;
 *  // `type` attribute value
 *  // https://developer.mozilla.org/en-US/docs/Web/HTML/Element/input#input_types
 *  type: string;
 *  value: number | string;
 * }) => number | string;
 */

export const valueInRange = ({ control, value }) => {
  const numValue = Number(value);
  return Math.max(
    control.min || 0,
    Math.min(control.max || numValue, numValue)
  );
};

export const valuePositive = ({ value }) => Math.abs(Number(value));

export const maxValue = (value, maxValue) => {
  return value && value.length > maxValue ? value.slice(0, maxValue) : value;
};
